export var MuiInputBase = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.white.main,
                borderRadius: "0px !important",
            });
        },
    },
};
